import Seo from "@/components/Seo";
import { PageHero } from "@/components/blocks";
import { COMPANY } from "@/data/site";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    desc: "How Cherians Tech Solutions handles information submitted through this website.",
    sections: [
      { h: "What We Collect", p: ["When you submit an enquiry, quote request, toner enquiry, AMC interest registration or contact form, we collect the details you provide — such as your name, phone number, location and requirement — so that we can respond to you."] },
      { h: "How We Use It", p: ["The information you submit is used only to respond to your enquiry, prepare quotations, provide services you request and maintain our business relationship with you. We do not sell your personal information."] },
      { h: "Storage", p: ["Enquiry details are stored securely in our internal systems. Access is restricted to authorized CTS team members."] },
      { h: "Your Choices", p: [`You can ask us to update or delete the information you have submitted by contacting us at ${COMPANY.email} or ${COMPANY.phone}.`] },
      { h: "Third-Party Services", p: ["This website links to WhatsApp and Google Maps. When you use these services, their own privacy policies apply."] },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    desc: "Terms governing the use of the Cherians Tech Solutions website.",
    sections: [
      { h: "General", p: ["This website is operated by Cherians Tech Solutions Private Limited, Mallappally, Kerala. By using this website you accept these terms."] },
      { h: "Enquiries & Quotations", p: ["Submitting an enquiry through this website does not constitute an order. Prices, availability and configurations are confirmed by CTS directly in response to your enquiry."] },
      { h: "Service Area", p: ["On-site technical support is provided within approximately 15–20 km of our Mallappally location."] },
      { h: "Accuracy of Information", p: ["We work to keep the information on this website accurate, but product availability and specifications may change. Details are confirmed at the time of enquiry."] },
      { h: "Contact", p: [`Questions about these terms: ${COMPANY.email} or ${COMPANY.phone}.`] },
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind];
  return (
    <>
      <Seo title={`${c.title} | ${COMPANY.brand}`} siteName={COMPANY.brand} description={c.desc} />
      <PageHero eyebrow="LEGAL" title={c.title} crumbs={[{ label: c.title }]} />
      <section className="section-pad bg-white">
        <div className="container-site max-w-3xl space-y-8" data-testid={`legal-${kind}`}>
          {c.sections.map((s) => (
            <div key={s.h}>
              <h2 className="h3-display mb-2">{s.h}</h2>
              {s.p.map((para) => (
                <p key={para.slice(0, 24)} className="lead-text">{para}</p>
              ))}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
